"use client";

import { useTranslations } from "next-intl";
import {
  Accordion,
  AccordionContent,
  AccordionItem,
  AccordionTrigger,
} from "@/components/ui/accordion";
import { SectionEyebrow, SectionTitle } from "../section-eyebrow";
import { ScrollReveal } from "../scroll-reveal";

export function FAQ() {
  const t = useTranslations("faq");
  const items = t.raw("items") as Array<{ q: string; a: string }>;

  return (
    <section
      id="faq"
      className="relative py-12 sm:py-20 lg:py-28"
    >
      <div className="mx-auto grid max-w-7xl gap-8 px-4 sm:px-6 lg:grid-cols-12 lg:gap-16 lg:px-8">
        <ScrollReveal className="flex flex-col gap-5 lg:col-span-5 lg:sticky lg:top-28 lg:self-start">
          <div className="flex items-center justify-between">
            <SectionEyebrow>{t("eyebrow")}</SectionEyebrow>
            <span className="font-mono text-[10px] uppercase tracking-[0.18em] text-muted-foreground/80 hidden sm:inline">
              / {items.length} questions
            </span>
          </div>
          <SectionTitle text={t("title")} italicLastWords={3} />
          <p data-blend className="mt-2 text-sm">
            {t("teaser")}{" "}
            <a
              href="#contact"
              className="underline-offset-4 hover:underline"
            >
              {t("teaserLink")}
            </a>
          </p>
        </ScrollReveal>

        <ScrollReveal className="lg:col-span-7">
          <Accordion className="w-full">
            {items.map((item, i) => (
              <AccordionItem
                key={item.q}
                value={`item-${i}`}
                className="last:border-b-0"
              >
                <AccordionTrigger data-blend className="py-5 text-start font-sans text-base font-medium hover:no-underline">
                  <span className="flex items-start gap-4">
                    <span className="font-mono text-[11px] uppercase tracking-[0.18em] shrink-0 pt-0.5">
                      / {String(i + 1).padStart(2, "0")}
                    </span>
                    <span>{item.q}</span>
                  </span>
                </AccordionTrigger>
                <AccordionContent data-blend className="ps-12 pb-5 text-sm leading-relaxed sm:text-base">
                  {item.a}
                </AccordionContent>
              </AccordionItem>
            ))}
          </Accordion>
        </ScrollReveal>
      </div>
    </section>
  );
}
